module.exports = __webpack_public_path__ + "static/images/rule-img4.c04be79.png";